import { render, staticRenderFns } from "./CostosPorTiposMantenimientos.vue?vue&type=template&id=47d082e6&"
import script from "./CostosPorTiposMantenimientos.vue?vue&type=script&lang=js&"
export * from "./CostosPorTiposMantenimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports